const convsArchiveTypes = {
  FETCH_CONVS_ARCHIVE_LIST: 'FETCH_CONVS_ARCHIVE_LIST',
  SET_CONVS_ARCHIVE_LIST: 'SET_CONVS_ARCHIVE_LIST',
  SET_LOADING_CONVS_ARCHIVE_LIST: 'SET_LOADING_CONVS_ARCHIVE_LIST',
  FETCH_USER_CONVS_ARCHIVE_DETAILS: 'FETCH_USER_CONVS_ARCHIVE_DETAILS',
  SET_USER_CONVS_ARCHIVE_DETAILS: 'SET_USER_CONVS_ARCHIVE_DETAILS',
  OPEN_CONVERSATION_FROM_ARCHIVE: 'OPEN_CONVERSATION_FROM_ARCHIVE',
  UPDATE_USER_ABOUT: 'UPDATE_USER_ABOUT',
  EXPORT_CONVS_LIST: 'EXPORT_CONVS_LIST',
  EXPORT_EXCEL_BASED_ON_PACKAGE: 'EXPORT_EXCEL_BASED_ON_PACKAGE',
};

export default convsArchiveTypes;
